/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class TableBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        blank: [['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--']],
    };

    render() {
        const { isOpen } = this.props;
        const { tit, data } = this.props.content;
        const { blank } = this.state;

        const renderColor = item => {
            if (item && item[2]) {
                const num = item[2].slice(0, item[2].length - 1);

                if (num < 0) {
                    return styles.green;
                } else if (num === 0) {
                    return styles.black;
                } else {
                    return '';
                }
            }
        };

        return (
            <div className={styles.table}>
                <h3>{data.name || '--'}</h3>
                <table border="0">
                    <tbody>
                        <tr>
                            {tit && tit.length > 0 && tit.map && tit.map((item, index) => <th key={index}>{item}</th>)}
                        </tr>
                        {data && data.data && data.data.length > 0 && data.data.map
                            ? data.data.map((item, index) => (
                                  <tr key={index} className={renderColor(item)}>
                                      {item.map((_item, index) => {
                                          if (index === 0 && _item) {
                                              return (
                                                  <td key={index}>
                                                      {typeof _item === 'string' ? (
                                                          _item
                                                      ) : _item.name ? (
                                                          <a href={_item.url} rel={rel} target="_blank">
                                                              {_item.name}
                                                          </a>
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          } else {
                                              return (
                                                  <td key={index}>
                                                      {isOpen && _item ? (
                                                          _item
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          }
                                      })}
                                  </tr>
                              ))
                            : blank.map((item, index) => {
                                  return (
                                      <tr key={index}>
                                          {item.map((_item, index) => {
                                              return (
                                                  <td key={index}>
                                                      <span style={{ color: '#273766' }}>--</span>
                                                  </td>
                                              );
                                          })}
                                      </tr>
                                  );
                              })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default errorBoundary(TableBox);
